import { connect } from 'react-redux'

import {
  doResetStates,
  doSetToCreatingNew,
  doSetToSearching,
  doSearchUsers,
  doCreateNewUser,
  doChangeUser,
  selectSearchTerm,
  selectIsSearching,
  selectIsCreating,
  selectMatchingUsers,
  selectIsSearchingStateLoading,
  selectIsSearchingStateError,
  selectIsCreatingStateLoading,
  selectIsCreatingStateError,
} from 'ducks/inAppCards/changeUser'

import View from './view'

const select = state => {
  return {
    isSearching: selectIsSearching(state),
    isCreatingNew: selectIsCreating(state),
    searchTerm: selectSearchTerm(state),
    users: selectMatchingUsers(state),
    isSearchingLoading: selectIsSearchingStateLoading(state),
    isSearchingError: selectIsSearchingStateError(state),
    isCreatingLoading: selectIsCreatingStateLoading(state),
    isCreatingError: selectIsCreatingStateError(state),
  }
}

const perform = {
  onModalOpen: doSetToSearching,
  onSearch: doSearchUsers,
  onSave: doCreateNewUser,
  onSelect: doChangeUser,
  openSearching: doSetToSearching,
  openCreating: doSetToCreatingNew,
  reset: doResetStates,
}

export default connect(select, perform)(View)
